import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 36px 20px 20px;
  position: relative;
  max-width: 300px;
  height: auto;
  border-radius: 8px;
  gap: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;

  .close {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  h1 {
    font-size: 1.2rem;
    font-weight: 600;
    text-align: center;
  }

  .checkbox {
    max-height: 60vh;
    min-height: 200px;
    overflow: auto;

    scrollbar-width: thin;
    scrollbar-color: black transparent;

    &::-webkit-scrollbar {
      width: 3px;
      height: 3px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      padding: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #a1a1a1;
    }
  }

  .button {
    margin: 0 auto;
  }
`;
